import { Ambulance, Flame, Shield, ShieldCheck } from 'lucide-react';

export type PerspectiveIcon = typeof Shield;

/** App-wide fallback when there is no active perspective or the name is unknown. */
export const DEFAULT_PERSPECTIVE_ICON: PerspectiveIcon = Shield;

/** Single source of truth: perspective name -> brand icon (mirrors the favicons). */
export const perspectiveIcon: Record<string, PerspectiveIcon> = {
  Veiligheid: Shield,
  GHOR: Ambulance,
  Brandweer: Flame,
  Politie: ShieldCheck,
};

export function iconForPerspective(name: string | null | undefined): PerspectiveIcon {
  return (name != null ? perspectiveIcon[name] : undefined) ?? DEFAULT_PERSPECTIVE_ICON;
}
